import React, { useState } from 'react';

import DromoImporter from './importer';
import { faUpload } from '@fortawesome/pro-solid-svg-icons';

import Button from 'shared/button';
import Snackbar from 'shared/snackbar';

import type { DromoImporterConfig, DromoImporterProps, Import } from './types';

interface Props {
  dromoImporterConfig?: DromoImporterConfig | null;
  dromoImporterProps: DromoImporterProps;
  showDromo: boolean;
  showIcon?: boolean;
  onCreate: (dromoImport: Import) => void;
  setShowDromo: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function DromoImporterButton({
  dromoImporterConfig,
  dromoImporterProps,
  showDromo,
  showIcon,
  onCreate,
  setShowDromo
}: Props) {
  const [showError, setShowError] = useState(false);

  return <>
    <Button.Primary
      disabled={showDromo || !dromoImporterConfig}
      icon={showIcon && faUpload}
      label="Import"
      onClick={() => setShowDromo(true)}
    />

    {showDromo && dromoImporterConfig &&
      <DromoImporter
        {...dromoImporterConfig}
        {...dromoImporterProps}
        onCreate={onCreate}
        onError={() => setShowError(true)}
        onHide={() => setShowDromo(false)}
      />
    }

    <Snackbar
      show={showError}
      text="Something went wrong."
      variant="danger"
      onClose={() => setShowError(false)}
    />
  </>;
}
